import { Tag } from "antd";
import React from "react";

export function OfferReceivedBadge() {
  return (
    <Tag color="success" className="border-0" style={{ borderRadius: '4px', fontWeight: 500 }}>
      Offer Received
    </Tag>
  );
}
